import { makeAlotOfEmptyStars, makeAlotOfStars } from "components/company-slides";
import AudioLogo from "../../assets/text-to-speech.svg";
import "../../styles/freelanceCard.css";
import { StarHalf } from "assets";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { shrotenTheVeryLongDesc } from "pages/freelance/singleFreelanceProfile";

export const toTitleCase= (str: string): string => {
    if (str===undefined) {
        return "";
    }
    return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

const FreelanceCard= ({rating, photo, skills, lastname, firstname, jobTitle, xp, ratersNumber, salary, audioAvailable, online, isWhite= false, id}: {rating: any, photo: any, skills: any, lastname: string, firstname: string, jobTitle: string, xp: any, ratersNumber: any, salary: number, audioAvailable: boolean, online: boolean, isWhite?: boolean, id: number})=> {
    let exp = Number(xp);
    const history= useNavigate();
    
    const [initialMousePos, setInitialMousePos]= useState<{x: number, y: number}>({x: 0, y: 0});
    const [isDragging, setIsDragging]= useState(false);

    const handleMouseDown= (event: any) => {
        setInitialMousePos({x: event.clientX, y: event.clientY});
        setIsDragging(false);
    };
    const handleMouseMove= (event: any) => {
        if(((event.clientX - initialMousePos.x)*(event.clientX - initialMousePos.x) + (event.clientY - initialMousePos.y)*(event.clientY - initialMousePos.y))>25){
            setIsDragging(true);
        }
    };
    const handleMouseUp= (event: any) => {
        if(!isDragging){
            goToProfile();
        }
    };
    
    const goToProfile= () => {
        history("/user/" + id);
    };
    
    return (<>
        <Link className={isWhite? "block freelCard-container white" : "block freelCard-container"} title={firstname + " " + lastname} to={"/user/" + id}>
            <div className="freelcard-inner text-primary-blue">
                <div className="upper-part">
                    <div className="image-container bg-center bg-cover" style={{backgroundImage: `url("${photo}")`}}>
                        <img src={photo} alt="freelance" className="opacity-0"/>
                        {online && <div className="online">En ligne</div>}
                        <div className="firstname truncate" >{toTitleCase(firstname)}</div>
                    </div>
                    <div className="info-container flex flex-col gap-1">
                        <div className="monthly-fee bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">{salary}€/mois</div>
                        <div className="info-inner flex flex-col">
                            {/* <div className={jobTitle?.length>16 ? jobTitle?.length>22 ? "job-title smaller" : "job-title small" : "job-title"}>{jobTitle}</div> */}
                            <div className={jobTitle?.length>16 ? jobTitle?.length>22 ? "job-title smaller" : "job-title small" : "job-title"}>{shrotenTheVeryLongDesc(jobTitle, 40, " ", ["&"], false)}</div>
                            {/* <div className={jobTitle?.length>16 ? jobTitle?.length>22 ? "job-title smaller" : "job-title small" : "job-title"}>Tay</div> */}
                            <div className="xp">Expérience : {`${isNaN(exp)?xp:exp +''+ 'ans'}`} </div>
                            <div className="rating flex flex-row gap-1">
                                <div className="stars flex flex-row">
                                    {makeAlotOfStars(Math.floor(rating))}
                                    {(((rating - Math.floor(rating))>= .5) && (rating < 5)) && <img src={StarHalf} alt="star half" />}
                                    {makeAlotOfEmptyStars(Math.floor(5 - rating))}
                                </div>
                                <div className="number-of-raters">({ratersNumber})</div>
                            </div>
                        </div>
                        <div className="audio flex flex-row">
                            {
                                audioAvailable &&
                                <>
                                    <img src={AudioLogo} alt="text-to-speech" />
                                    <p className={!audioAvailable ? "longer" : ""}>Présentation audio {!audioAvailable && "non"} disponible</p>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="lower-part flex flex-row">
                    {
                        (skills.length > 4) ?
                        <>
                            <div className="comp max-w-[110px] truncate" title={skills[0]}>{skills[0]}</div>
                            <div className="comp max-w-[110px] truncate" title={skills[1]}>{skills[1]}</div>
                            <div className="comp max-w-[110px] truncate" title={skills[2]}>{skills[2]}</div>
                            <div className="comp max-w-[110px] truncate" title={skills[3]}>{skills[3]}</div>
                            <div className="comp max-w-[110px] truncate" title={(skills.length - 4) + " compétence(s) en plus"}>+{skills.length - 4}</div>
                        </> :
                        <>
                        {
                            skills.map((skill: any, index: any)=>(
                                <div className="comp max-w-[110px] truncate noplus" title={skill} key={"moreSkill-" + index}>{skill}</div>
                            ))
                        }
                        </>
                    }
                </div>
            </div>
        </Link>
    </>);
};

export const FreelanceCardLoading= ({isWhite= false}: {isWhite: boolean}) => {
    return<>
        <div className={isWhite ? "loading-card-container placeholder white" : "loading-card-container placeholder"} title={"Chargement..."}>
            <div className="loading-card-upper">
                <div className="loading-card-image"></div>
                <div className="loading-card-upper-inner">
                    <div className="loading-card-u-inner"></div>
                    <div className="loading-card-u-inner delay-1"></div>
                    <div className="loading-card-u-inner dealy-2"></div>
                </div>
            </div>
            <div className="loading-card-lower">
                <div className="loading-card-lower-inner"></div>
                <div className="loading-card-lower-inner delay-1"></div>
                <div className="loading-card-lower-inner delay-2"></div>
            </div>
        </div>
    </>;
};

export default FreelanceCard;